import React from 'react';
import PropTypes from 'prop-types';

export const SvgUsers = ({ width, height }) => (
  <svg width={width || '18px'} height={height || '13px'} viewBox="0 0 18 13" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-108.000000, -292.000000)" stroke="#000000" strokeWidth="2">
        <g transform="translate(105.000000, 287.000000)">
          <path d="M15.3333333,18 L15.3333333,16.6666667 C15.3333333,15.1939073 14.139426,14 12.6666667,14 L7.33333333,14 C5.860574,14 4.66666667,15.1939073 4.66666667,16.6666667 L4.66666667,18" />
          <circle cx="10" cy="8.66666667" r="2.66666667" />
          <path d="M19.3333333,18 L19.3333333,16.6666667 C19.3324269,15.4514118 18.5099992,14.3904801 17.3333333,14.0866667" />
          <path d="M14.6666667,6.08666667 C15.8466099,6.38877986 16.6718955,7.4519941 16.6718955,8.67 C16.6718955,9.8880059 15.8466099,10.9512201 14.6666667,11.2533333" />
        </g>
      </g>
    </g>
  </svg>
);

SvgUsers.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};
